<template>
  <div id="groundsWrapper">
    <button @click="$emit('newGround', ground)" class="colorHolder" v-for="ground of assets.grounds" :key="ground">
      <img :src="require('../../assets/grounds/' + ground.file)" />
    </button>
  </div>
</template>

<script>
import Assets from '../../utils/webgl/Assets.js';
export default {
  name: 'GroundConfig',
  data() {
    return {
      assets: new Assets(),
    };
  },
};
</script>

<style scoped>
#groundsWrapper {
  position: fixed;
  z-index: 10;

  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;

  right: 1.5rem;
}
.colorHolder {
  border-radius: 50%;
  overflow: hidden;
  transition-duration: 100ms;
}
.colorHolder:hover {
  transform: scale(1.1);
}
.colorHolder img {
  height: 100%;
  width: 100%;
  object-fit: fill;
}
@media (orientation: landscape) {
  #groundsWrapper {
    top: calc(75px + 0.5rem);
  }
  .colorHolder {
    height: 5vh;
    width: 5vh;
  }
}
@media (orientation: portrait) {
  .colorHolder {
    height: 10vw;
    width: 10vw;

    max-height: 50px;
    max-width: 50px;
  }
  #groundsWrapper {
    top: calc((100vh - 91px) / 2 + 75px + 2rem);
    flex-direction: column;
  }
}
</style>
